// extracted by mini-css-extract-plugin
export default {"root":"P45R7","tablet":"TgcGa","desktop":"JKSkl"};